<template>
  <div
    id="top"
    class="w-100 space-for-navbar mb-3"
  >
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>Opportunity</title>
          <g id="Splashes">
            <g id="Opportunity">
              <image
                id="OpportunityPic"
                width="5001"
                height="2814"
                transform="scale(0.2)"
                :xlink:href="require('../assets/splashes/Splashes1.jpg')"
              />
              <text
                id="OpportunityLabel"
                class="bmg-splashes-1"
                transform="translate(378.48 299.87)"
              >Oppo<tspan
                class="bmg-splashes-2"
                x="112.88"
                y="0"
              >r</tspan><tspan
                x="129.52"
                y="0"
              >tuni</tspan><tspan
                class="bmg-splashes-3"
                x="210.52"
                y="0"
              >t</tspan><tspan
                class="bmg-splashes-4"
                x="226.36"
                y="0"
              >y</tspan><tspan
                x="248.36"
                y="0"
              >: </tspan><tspan class="bmg-splashes-5"><tspan
                x="-7.93"
                y="30"
              >Solvi</tspan><tspan
                class="bmg-splashes-6"
                x="50.12"
                y="30"
              >n</tspan><tspan
                x="67.1"
                y="30"
              >g Medical Needs</tspan><tspan
                x="-15.18"
                y="60"
              >Un</tspan><tspan
                class="bmg-splashes-6"
                x="21.55"
                y="60"
              >m</tspan><tspan
                x="48.12"
                y="60"
              >et </tspan><tspan
                class="bmg-splashes-7"
                x="79.92"
                y="60"
              >b</tspan><tspan
                x="96.5"
                y="60"
              >y </tspan><tspan
                class="bmg-splashes-8"
                x="116.6"
                y="60"
              >C</tspan><tspan
                x="134"
                y="60"
              >o</tspan><tspan
                class="bmg-splashes-9"
                x="149.67"
                y="60"
              >n</tspan><tspan
                class="bmg-splashes-7"
                x="166.34"
                y="60"
              >v</tspan><tspan
                x="179.52"
                y="60"
              >entional</tspan><tspan
                x="-3.03"
                y="90"
              >O</tspan><tspan
                class="bmg-splashes-10"
                x="17.95"
                y="90"
              >r</tspan><tspan
                class="bmg-splashes-11"
                x="28.35"
                y="90"
              >t</tspan><tspan
                class="bmg-splashes-6"
                x="38.5"
                y="90"
              >h</tspan><tspan
                x="55.47"
                y="90"
              >opedic Ha</tspan><tspan
                class="bmg-splashes-12"
                x="182.57"
                y="90"
              >r</tspan><tspan
                x="192.27"
                y="90"
              >d</tspan><tspan
                class="bmg-splashes-13"
                x="209.22"
                y="90"
              >w</tspan><tspan
                x="230.79"
                y="90"
              >a</tspan><tspan
                class="bmg-splashes-14"
                x="245.54"
                y="90"
              >r</tspan><tspan
                x="255.25"
                y="90"
              >e</tspan></tspan></text>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <!-- Section: 6 Million Problems -->
    <section
      id="intro-video"
      class="my-5"
    >
      <div class="">
        <h1 class="font-weight-bold text-dark text-center my-3">
          6 Million Times Per Year Worldwide
        </h1>
        <p class="h3 text-dark text-center w-responsive mx-auto mb-5">
          Some bones are broken so severely that surgeons must surgically realign
          and fixate them for regrowth.
        </p>
        <div class="centered-on-page h4">
          <div class="row w-md-80">
            <!-- Grid column -->
            <div
              class="col-lg-6 centered-on-page pointer"
              @click="doVideo"
            >
              <!-- <img class="img-fluid" src="../assets/purchased_pics/car-automobile-vehicle-crash-motor-vehicle-collision-1208483-pxhere.com.jpg" alt="Car Wreck"> -->
              <img
                class="img-fluid"
                src="../assets/purchased_pics/accident.jpg"
                alt="Car Wreck"
              >
              <div class="centered-over-top">
                <button class="pulse bmg-btn-white-outline bg-white centered-on-page">
                  <span class="h5-responsive m-0 p-0">Watch Video</span>&nbsp;<font-awesome-icon
                    icon="play"
                    size="3x"
                    class="text-primary"
                  />
                </button>
              </div>
            </div>
            <!-- Grid column -->
            <div class="col-lg-6 align-middle centered-on-page">
              <div>
                <!-- Section description -->
                <!-- Grid row -->
                <div class="row my-3">
                  <!-- Grid column -->
                  <div class="col-2 text-right">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      size="2x"
                      class="text-danger"
                    />
                  </div>
                  <!-- End Grid column -->
                  <!-- Grid column -->
                  <div class="col-xl-10 col-md-11 col-10">
                    <p class="text-dark">
                      Using a variety of orthopedic hardware, including bone plates, screws, nails, staples and wires.
                    </p>
                  </div>
                  <!-- End Grid column -->
                </div>
                <!-- End Grid row -->
                <!-- Grid row -->
                <div class="row">
                  <!-- Grid column -->
                  <div class="col-2 text-right">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      size="2x"
                      class="text-danger"
                    />
                  </div>
                  <!-- End Grid column -->
                  <!-- Grid column -->
                  <div class="col-xl-10 col-md-11 col-10">
                    <p class="text-dark">
                      Horses and other animals may be euthanized when current hardware offers no solutions.
                    </p>
                  </div>
                  <!-- End Grid column -->
                </div>
                <!-- End Grid row -->
              </div>
            </div>
            <!--End Grid column-->
          </div>
          <!-- End Grid row -->
          <div id="hardware-loosens" />
        </div>
      </div>
    </section>
    <div
      id="intro-video"
      v-show="showVideo"
      class="bmg-modal-mask w-100 h-100"
    >
      <div class="bmg-modal-wrapper">
        <div class="bmg-modal-container p-0 m-0 centered-on-page">
          <!-- <video id="BMGIntroVideo" autoplay preload='none' controls
            :style="(windowWidth > (windowHeight * 1.7)) ? {height: '100%', width: (windowHeight * 1.675) + 'px'} : {width: '100%', height: (windowWidth * 0.5625) + 'px'}"
            v-on:play="videoEventsHandler"
            v-on:playing="videoEventsHandler"
            v-on:pause="videoEventsHandler"
            v-on:ended="videoEventsHandler"
            v-on:seeked="videoEventsHandler"
            v-on:timeupdate="videoEventsHandler"
            v-on:error="videoEventsHandler"
          >
            <source :src="require('../assets/videos/BMGV2.mp4')" type="video/mp4">
          </video> -->
          <iframe
            id="vimeo-player"
            src="https://player.vimeo.com/video/368980364?autoplay=0&loop=0"
            :width="(windowWidth > (windowHeight * 1.7)) ? (windowHeight * 1.6) : windowWidth"
            :height="(windowWidth > (windowHeight * 1.7)) ? windowHeight: (windowWidth * 0.5)"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          />
        </div>
      </div>
      <svg
        id="BMGIntroVideoClose"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50.98"
        class="bmg-popups-close-btn-tight"
        @click="closeVideo()"
      >
        <title>Close</title>
        <g
          id="CloseButton"
          data-name="CloseButton"
        >
          <circle
            id="CloseButtonEllipse"
            class="bmg-popups-close-button-1"
            cx="25"
            cy="25"
            r="23"
          />
          <text
            id="CloseButton-X"
            class="bmg-popups-close-button-2"
            transform="translate(10.43 39.8)"
          >X</text>
        </g>
      </svg>
    </div>
    <!-- Section: Almost Always Loosens -->
    <section class="card mx-4 p-3 bmg-half-page-section-view-dark text-center">
      <h1 class="text-center mt-3">
        Internal Fixation Hardware Almost Always* Loosens Causing Many Problems
      </h1>
      <div class="row text-left">
        <div class="col-md-7">
          <div class="d-flex flex-column centered-on-page  h-100 m-3">
            <p class="m-3 h4-responsive">
              <span class="h3-responsive text-bold">Within a few hours to a few days:</span>
              <ul class="mx-3">
                <li>Optimal compression is lost, and Primary Healing ceases</li>
                <li>
                  Time to bony union extends > 2 months for Secondary Healing, adding
                  <ul>
                    <li>Inflammation, fracture gap widening with hematoma resolving into granulation tissue</li>
                    <li>Soft callus and</li>
                    <li>Hard callus reactions</li>
                  </ul>
                </li>
                <li>
                  Early weight-bearing and exercise must cease or be severely
                  limited for prolonged periods, otherwise the result may be
                  re-surgery, from:
                  <ul>
                    <li>Malunion or Non-union</li>
                    <li>Broken Plates, Re-Broken Bones (e.g., equine long-bone fractures)</li>
                    <li>Screwsbreaking or twisting out (e.g., of compression plates)</li>
                  </ul>
                </li>
                <li>
                  The result is atrophy of bone and muscle and predisposition to further complications
                </li>
                <li>
                  Permanent shortening of tendons, ligaments and neurovascular bundles
                </li>
                <li>
                  Joint stiffness - abnormal adhesion
                </li>
                <li>
                  Deep vein blood clots
                </li>
                <li>
                  Extensive rehabilitation &amp; pain med addiction
                </li>
              </ul>
              <strong>*</strong> Intermedullary nails may not loosen, but are highly invasive,
              do not compress fracture zones uniformly, nor enable primary bone growth.
            </p>
          </div>
        </div>
        <div class="col-md-5 centered-on-page">
          <div class="w-100 centered-on-page">
            <div class="text-center">
              <h2 class="text-center mt-3">
                Expectations are that by using BMG implants, the time to bony union
                should be markedly reduced.
              </h2>
              <img
                src="../assets/purchased_pics/Surgery.jpg"
                class="w-100"
                alt="BMG Logo"
              >
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="centered-on-page">
        <a type="button" class="pulse pointer bmg-btn-white mb-3 centered-on-page w-md-20"
          href="../static/FractureHealingAndExpectedImpactOfBMGTechnology.pdf" target="_blank">
          <span class="h5-responsive m-0 p-0">Learn More&nbsp;&nbsp;</span><font-awesome-icon icon="file-pdf" size="2x" class="text-primary"/></a>
      </div> -->
    </section>
  </div><!-- End of OpportunityPage-->
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
import Player from '@vimeo/player'
// let Vimeo = require('vimeo').Vimeo
// window.$ = require('jquery')

// let client = new Vimeo( // Get creds at https://developer.vimeo.com/apps/158805
//   'bc00e8b06ab2841dcc527ae0758f4000df0ad35a', // Client ID
//   'ERH4F8x0OaO+CZyxViZsrOTc3WeQJy7y0hTFT09y6LiVMr9mZm2CwK3+HgmWKMyXg6eKX0NluN9vD8A83/Ck9jjxiUAnHe0DIDlNqYC4YyAws4lkXpoKbIpKn1564axd', // Client Secret
//   '3e31544507855cca7f101de6d22f568d') // Access Token for Public Vids Only

export default {
  mixins: [SecurityCheckMixin],
  name: 'OpportunityPage',
  data: function () {
    return {
      showVideo: false,
      bannerHeight: 59,
      windowHeight: -1,
      windowWidth: -1,
      player: null,
      divisor: 5, // Every 5% set a marker
      videoStatus: {
        current: 0,
        greatestMarker: -1,
        isPlaying: false
      }
    }
  },
  computed: {},
  components: {},
  methods: {
    respondToWindowSizeChange () {
      if (window.innerHeight) {
        this.windowHeight = window.innerHeight - this.bannerHeight
      } else if (document.body && document.body.offsetHeight) {
        this.windowHeight = document.body.offsetHeight - this.bannerHeight
      }

      if (window.innerWidth) {
        this.windowWidth = window.innerWidth
      } else if (document.body && document.body.offsetWidth) {
        this.windowWidth = document.body.offsetWidth
      }

      // console.log('Window = ' + this.windowWidth + ' x ' + this.windowHeight)
    },
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    },
    closeVideo () {
      this.showVideo = !this.showVideo
      this.player.pause()
    },
    doVideo () {
      // console.log('Showing Player')
      this.showVideo = !this.showVideo
      this.player = new Player('vimeo-player')
      this.player.on('play', this.videoEventsHandler)
      this.player.on('timeupdate', this.videoEventsHandler)
      this.player.on('ended', this.videoEventsHandler)
      this.player.on('error', function (e) {
        console.error('Video Player Error', e)
        this.$gtm.trackEvent({
          'event': 'video-event',
          'vid-event-category': 'BMG Intro Video',
          'vid-event-action': 'Video Error',
          'vid-event-label': e
        })
      })
      this.player.play()
    },
    videoEventsHandler (e) {
      // console.log('videoEventsHandler:', e.percent * 100)
      // Let's set the save the current player's video time in our status object
      this.videoStatus.current = e.seconds
      var pct = (100 * e.percent)
      // console.log('Vid CurrentTime = ', Math.round(e.target.currentTime))
      // We just want to send the percent events once
      for (var j in this.videoStatus.progressMarkers) {
        j = j * 1.0 // Make it a double instead of an integer
        if (pct >= j && pct > this.videoStatus.greatestMarker) {
          this.videoStatus.greatestMarker = j
          // console.log('New GreatestMaker =', this.videoStatus.greatestMarker)
        }
      }
      // current bucket hasn't been already sent to GA?, let's push it to GTM
      if (-1 !== this.videoStatus.greatestMarker && !this.videoStatus.progressMarkers[this.videoStatus.greatestMarker]) {
        this.videoStatus.progressMarkers[this.videoStatus.greatestMarker] = true
        // console.log('this.videoStatus.progressMarkers = ', this.videoStatus.progressMarkers)
        // console.log('Sending Track Event to Google Tag Manager', this.videoStatus.greatestMarker + '%')
        if (0 === this.videoStatus.greatestMarker) {
          // We are at the beginning... Just started playing...
          console.log('Video Play Started')
          this.$gtm.trackEvent({
            'event': 'video-event',
            'vid-event-category': 'BMG Intro Video',
            'vid-event-action': 'Video Play Started',
            'vid-event-label': 'BMG Video'
          })
        } else if (100 === this.videoStatus.greatestMarker) {
          // We are at the end... Just ended playing...
          console.log('Video Play Ended')
          this.$gtm.trackEvent({
            'event': 'video-event',
            'vid-event-category': 'BMG Intro Video',
            'vid-event-action': 'Video Ended',
            'vid-event-label': '100%',
            'vid-event-value': 100
          })
        } else {
          // We are somewhere in the middle
          console.log('Video % Complete', this.videoStatus.greatestMarker + '%')
          this.$gtm.trackEvent({
            'event': 'video-event',
            'vid-event-category': 'BMG Intro Video',
            'vid-event-action': 'Video % Complete',
            // We are using sanitizing the current video src string, and getting just the video name part
            'vid-event-label': this.videoStatus.greatestMarker + '%',
            'vid-event-value': this.videoStatus.greatestMarker
          })
        }
      }
    }
  },
  beforeMount () {
  },
  mounted () {
    // Let's set the progress markers, so we can know afterwards which ones have been already sent.
    this.videoStatus.progressMarkers = {}
    for (var j = 0; 100 > j; j++) {
      this.videoStatus.progressPoint = this.divisor * Math.floor(j / this.divisor)
      this.videoStatus.progressMarkers[this.videoStatus.progressPoint] = false
    }
    this.videoStatus.progressPoint = 100
    this.videoStatus.progressMarkers[this.videoStatus.progressPoint] = false
    console.log('MOUNTED: this.videoStatus.progressMarkers = ', this.videoStatus.progressMarkers)

    this.respondToWindowSizeChange()
    window.addEventListener('resize', this.respondToWindowSizeChange)
    // console.log('Section = ' + this.$route.params.section)
    this.scrollToSection(this.$route.params.section)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
